'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    NotFoundServer: {
        displayName: 'NotFoundServer'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/NotFoundServer/NotFoundServer.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var NotFoundServer = _wrapComponent('NotFoundServer')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        lang: state.lang
    };
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(NotFoundServer, _Component);

    function NotFoundServer() {
        (0, _classCallCheck3.default)(this, NotFoundServer);
        return (0, _possibleConstructorReturn3.default)(this, (NotFoundServer.__proto__ || (0, _getPrototypeOf2.default)(NotFoundServer)).apply(this, arguments));
    }

    (0, _createClass3.default)(NotFoundServer, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForContainer('NotFoundServer');
            var helmetTitle = this.props.lang['store.helmet.server_is_unavailable'];

            return _react3.default.createElement(
                'div',
                { className: 'row' },
                _react3.default.createElement(_reactHelmet2.default, { title: helmetTitle }),
                _react3.default.createElement(View, { lang: this.props.lang })
            );
        }
    }]);
    return NotFoundServer;
}(_react2.Component)) || _class));

exports.default = NotFoundServer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFoundServer/NotFoundServer.jsx
// module id = 1817
// module chunks = 0